<template>
  <div class="imglist">
    <Tabs v-model="posdata.status" type="card">
      <TabPane label="待审核" name="0"></TabPane>
      <TabPane label="审核通过" name="1"></TabPane>
      <TabPane label="未通过" name="2"></TabPane>
    </Tabs>
    <div class="searchw">
      <Spin fix v-if="isShowPercent">
        <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
        <div>{{ ShowPercentMsg }}</div>
      </Spin>
      <Form inline :label-width="52">
        <FormItem label="产品名称" :label-width="56" style="width: 230px">
          <Input maxlength="50" v-model="posdata.goods_name" @on-keyup.13="search"></Input>
        </FormItem>
        <FormItem label="生产厂家" :label-width="56" style="width: 260px">
          <Input maxlength="50" v-model="posdata.maker" @on-keyup.13="search"></Input>
        </FormItem>
        <FormItem label="批准文号" :label-width="56" style="width: 210px">
          <Input maxlength="32" v-model="posdata.pass_no" @on-keyup.13="search"></Input>
        </FormItem>
        <FormItem label="" :label-width="0">
          <Button type="default" icon="ios-search" @click="search" @keyup.13="search">搜索</Button>
        </FormItem>
      </Form>
    </div>
    <Table size="small" :columns="columns" :data="data.data" :loading="table_loading">
      <template slot-scope="{row}" slot="img">
        <div v-viewer>
          <img class="goodsimg" v-lazy="ApiUrl+row.path" style="display: block;margin:10px auto;" />
        </div>
      </template>
      <template slot-scope="{row,index}" slot="status">
        <RadioGroup v-model="data.data[index].status" vertical @on-change="examImgStatus(row.id,index,$event)">
          <Radio :label="1"><span style="color:green">通过</span></Radio>
          <Radio :label="2"><span style="color: #999">未通过</span></Radio>
        </RadioGroup>
      </template>
      <template slot-scope="{row}" slot="action">
        <Button type="warning" size="small" @click="delImg(row.id)">删除</Button>
      </template>
    </Table>
    <div class="footer-m">
      <Page class-name="pagew page-r" :total="data.total" :current="data.current_page" :page-size="data.per_page" :page-size-opts="[15,30,50,100,200,500]" show-sizer show-total @on-change="page" @on-page-size-change="change_pagesize" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'GoodsList',
  data(){
    return {
      columns:[
        {title: 'ID',key: 'id', width: 66},
        {title: '产品名称',key: 'goods_name',minWidth:130},
        {title: '单位',key: 'unit',minWidth:60,align:'center'},
        {title: '规格',key: 'specs',minWidth:150},
        {title: '生产厂家',key: 'maker',minWidth:200},
        {title: '批准文号',key: 'pass_no',minWidth:150},
        {title: '图片',slot: 'img', minWidth: 120,align:'center'},
        {title: '审核状态',slot: 'status',minWidth:150,align:'center'},
        {title: '更新时间',key: 're_time',minWidth:150,align:'center'},
        {title: '操作',slot: 'action',width:80,align:'center'},
      ],
      data:[],
      table_loading:false,
      posdata:{
        goods_name:'',
        maker:'',
        pass_no:'',
        status:0,
        page:1,
        page_size:15
      },
      isShowPercent:false,
      ShowPercentMsg:'处理中...'
    }
  },
  watch:{
    "posdata.status"(){
      this.search()
    }
  },
  created() {
    this.init();
  },
  methods:{
    init:function (){
      var _this=this;
      this.table_loading=true;
      this.requestApi('/adm/imglist.html',this.posdata).then(function (res){
        _this.table_loading=false;
        if(res.status==1) _this.data=res.data;
      })
    },
    delImg:function(imgId) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确定要删除吗？</p>',
        onOk: () => {
          if(this.isShowPercent) return;
          this.isShowPercent = true;
          this.requestApi('/adm/delImg',{imgId:imgId}).then((res)=>{
            this.isShowPercent = false;
            if(res.status){
              this.$Message.success(res.msg);
              this.init();
            }else{
              this.$Message.error(res.msg);
            }
          })
        }
      });
    },
    /**
     * 搜索
     */
    search:function (){
      this.posdata.page=1;
      this.init();
    },
    /**
     * 翻页
     */
    page:function (page){
      this.posdata.page=page;
      this.init();
    },
    /**
     * 切换分页条数
     */
    change_pagesize:function (size){
      this.posdata.page_size=size;
      if(this.posdata.page==1) this.init();
    },
    /** 图片审核 */
    examImgStatus:function(imgId,index,val){
      if(this.isShowPercent) return;
      this.isShowPercent = true;
      this.requestApi('/adm/setImgStatus', {imgId:imgId,value:val}).then((res)=>{
        this.isShowPercent = false;
        if(res.status){
          this.$Message.success(res.msg);
          this.init();
        }else{
          this.$Message.error(res.msg);
          this.data.data[index].status = val?0:1;
        }
      })
    },
    upProgress(res){
      console.log(res)
      // if(res.percent == -1) this.isShowPercent = false;
      // else{
      //   this.ShowPercentMsg = '上传中...';
      //   this.isShowPercent = true;
      // }
    },
    upSuccess(res){
      this.specsUnit[res.img_name].imgs.push(res.response.imgVal)
    },
  }
}
</script>
<style lang="less">
.nouse{}
.imglist{
  .goodsimg{max-height: 44px; max-width: 88px;}
}
</style>
